import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AIChatBoxComponent } from 'src/app/shared/modals/aichat-box/aichat-box.component';
import { AIChatEnum } from '../../enums/ai-chat-enum';
import { EntityTypeEnum } from '../../enums/entity-type-id-enum';


@Injectable({
  providedIn: 'root'
})
export class AIChatModalService {
  userProfile: any = undefined;
  documents: any;
  messageHistory: any = undefined;
  isOpen: boolean = false;
  modalRef!: NgbModalRef;

  preloaded: boolean = false;

  modalEntityId: string | undefined = undefined;
  modalEntityType: EntityTypeEnum | undefined = undefined;
  modalFileId: string | undefined = undefined;
  modalName: string | undefined = undefined;

  @Output() modelChanged = new EventEmitter<any>();

  constructor(private modalService: NgbModal) { }

  isOpened(): boolean {
    return this.isOpen;
  }

  hasBeenLoaded(): boolean {
    return this.preloaded;
  }

  set preload(loadStatus: any) { this.preloaded = loadStatus; }


  setProfile(profileImage: any) { this.userProfile = profileImage; };

  setOpenModalId(entityId: string | undefined, fileId: string | undefined, entityType: EntityTypeEnum | undefined, name: string | undefined) {
    this.modalEntityId = entityId;
    this.modalEntityType = entityType;
    this.modalFileId = fileId;
    this.modalName = name;
    if (this.isOpen) {
      this.modalRef.componentInstance.modalEntityId = this.modalEntityId;
      this.modalRef.componentInstance.modalEntityType = this.modalEntityType;
      this.modalRef.componentInstance.modalFileId = this.modalFileId;
      this.modalRef.componentInstance.modalName = this.modalName;
      this.modalRef.componentInstance.scrollToBottom();
    }

  };

  openModal(showVideo: boolean, newChat?: boolean, pdf?: boolean, pdfTags?: string[]) {
    if (this.isOpen === false) {
      this.isOpen = true;
      this.modalRef = this.modalService.open(AIChatBoxComponent, { windowClass: "customModalClassChat", size: 'md', centered: false, backdrop: false, keyboard: false, scrollable: true });
      this.modalRef.componentInstance.suggestionsHidden = false;
      if (this.modalFileId) {
        this.modalRef.componentInstance.showVideo = showVideo;
        this.modalRef.componentInstance.modalEntityId = this.modalEntityId;
        this.modalRef.componentInstance.modalEntityType = this.modalEntityType;
        this.modalRef.componentInstance.modalFileId = this.modalFileId;
        this.modalRef.componentInstance.modalName = this.modalName;
        this.modalRef.componentInstance.predefinedTags = pdfTags;
        this.modalRef.componentInstance.suggestionsHidden = true;
        this.modalRef.componentInstance.scrollToBottom();
      }
      this.modalRef.componentInstance.userAvatar = this.userProfile;
      this.modalRef.componentInstance.showVideo = showVideo;

      if (this.messageHistory === undefined) {
        this.modalRef.componentInstance.messageHistory = [
        
        ];
      }


      if ((newChat)) {
        this.modalRef.componentInstance.messageHistory = this.messageHistory;
        this.modalRef.componentInstance.showVideo = showVideo;
        if (pdf) {
          this.modalRef.componentInstance.messageHistory = [
            { message: `Ask me anything regarding "${this.modalName}" document.`, messageType: AIChatEnum.Response, time: new Date(), }
          ];
        } else {
          this.modalRef.componentInstance.messageHistory = [
          
          ];
        }
      }

      var sub: Subscription = this.modalRef.closed.subscribe(() => {
        this.isOpen = false;
        if (this.modalRef.componentInstance.messageHistory) {
          this.messageHistory = this.modalRef.componentInstance.messageHistory;
          this.modelChanged.emit(this.modalRef.componentInstance.messageHistory);
        }
        sub.unsubscribe();
      })
    }
  }

  closeModal() {
    this.modalEntityId = undefined;
    this.modalEntityType = undefined;
    this.modalFileId = undefined;
    this.modalName = undefined;
    this.modalRef.close();
  }
}
